// DS-3309: a Send request's purpose. Mirrors the BFF RequestSendType serialized onto
// ClientRequestDetail.sendType. Single source of truth for these literals so the
// "is this EMD?" concept isn't re-derived against magic strings across views.
export enum SendType {
    Emd = 'Emd',
    CashToClose = 'CashToClose',
    Other = 'Other',
}

/**
 * Shared predicate for "is this an earnest money deposit send request?".
 *
 * The comparison is case-insensitive on purpose: `sendType` arrives as a serialized
 * enum whose casing isn't contractually guaranteed, so the tolerance lives here in
 * exactly one place rather than being copy-pasted as `?.toLowerCase() === 'emd'` at
 * every call site.
 */
export const isEmdSendType = (sendType: SendType | string | null | undefined): boolean =>
    (sendType ?? '').toLowerCase() === SendType.Emd.toLowerCase();

/**
 * Shared predicate for "is this a cash-to-close send request?".
 *
 * Deliberately NOT `!isEmdSendType(...)`: `Other` (and a null sendType from an older
 * BFF payload) are neither EMD nor cash-to-close, so features scoped to cash-to-close
 * must test for it positively. Case tolerance matches `isEmdSendType` for the same reason.
 */
export const isCashToCloseSendType = (sendType: SendType | string | null | undefined): boolean =>
    (sendType ?? '').toLowerCase() === SendType.CashToClose.toLowerCase();
